import { useCallback } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Listable } from 'listable'
import Row from './row'
import Filters from '../filters'

import {
  actions,
  config
} from '../../module'

const List = ({ account, model }) => {

  const renderItem = useCallback((item, index, itemProps) => (
    <Row
      key={index}
      account={account}
      item={item}
      {...itemProps}/>
  ), [account])


  const { ids, filters, ...rest } = model

  return (
    <Listable
      actions={actions}
      config={config}
      filters={Filters}
      model={rest}
      renderItem={renderItem}/>
  )
}

List.propTypes = {
  account: PropTypes.string,
  model: PropTypes.object.isRequired,
}

const mapStateToProps = ({ reportEndOfLease, settings }) => ({
  account: settings?.account,
  model: reportEndOfLease,
})

export default connect(
  mapStateToProps,
  {}
)(List)
